const { fetchWithRetry } = require('./utils'); // A utility function to parse cookies  

// Function to create a pass purchase  
const createPassPurchase = async (passPurchaseData) => {
    try {
        const response = await fetchWithRetry('/api/passPurchases', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(passPurchaseData),
        });

        if (!response.ok) {
            throw new Error(`Error creating pass purchase: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error creating pass purchase:', error);
        throw error;
    }
};

// Function to get all pass purchases  
const getPassPurchases = async () => {
    try {
        const response = await fetchWithRetry('/api/passPurchases', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error fetching pass purchases: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching pass purchases:', error);
        throw error;
    }
};

// Function to get pass purchases by user  
const getPassPurchasesByUser = async (userId) => {
    try {
        const response = await fetchWithRetry(`/api/passPurchases/user/${userId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error fetching pass purchases for user: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching pass purchases for user:', error);
        throw error;
    }
};

// Function to update a pass purchase  
const updatePassPurchase = async (passPurchaseId, passPurchaseData) => {
    try {
        const response = await fetchWithRetry(`/api/passPurchases/${passPurchaseId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(passPurchaseData),
        });

        if (!response.ok) {
            throw new Error(`Error updating pass purchase: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error updating pass purchase:', error);
        throw error;
    }
};

// Function to delete a pass purchase  
const deletePassPurchase = async (passPurchaseId) => {
    try {
        const response = await fetchWithRetry(`/api/passPurchases/${passPurchaseId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error deleting pass purchase: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error deleting pass purchase:', error);
        throw error;
    }
};

// Function to get pass purchase by ID number  
const getPassPurchaseByIdNumber = async (idNumber) => {
    try {
        const response = await fetchWithRetry(`/api/passPurchases/id_number/${idNumber}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error fetching pass purchase by ID number: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching pass purchase by ID number:', error);
        throw error;
    }
};

// Function to get pass purchases by name  
const getPassPurchasesByName = async (name) => {
    try {
        const response = await fetchWithRetry(`/api/passPurchases/name/${name}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error fetching pass purchases by name: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching pass purchases by name:', error);
        throw error;
    }
};

module.exports = {
    createPassPurchase,
    getPassPurchases,
    getPassPurchasesByUser,
    updatePassPurchase,
    deletePassPurchase,
    getPassPurchaseByIdNumber,
    getPassPurchasesByName,
};  